<template>
  <v-dialog v-model="showModal" persistent max-width="390">
    <v-card>
      <v-card-title class="headline greyMedium--text">{{ title }}</v-card-title>

      <v-card-text>
        {{ text }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="cancelButtonText" color="primary" outlined @click="cancel()">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn v-if="confirmButtonText" color="primary" @click="confirm()">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'BasicModal',
  props: {
    modalCode: { 
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('modal', ['modals']),
    showModal() {
      return this.modals[this.modalCode]?.show || false;
    },
    title() {
      return this.modals[this.modalCode]?.title || '';
    },
    text() {
      return this.modals[this.modalCode]?.text || '';
    },
    confirmButtonText() {
      return this.modals[this.modalCode]?.confirmButtonText || '';
    },
    cancelButtonText() {
      return this.modals[this.modalCode]?.cancelButtonText || '';
    },
    onConfirm() {
      return this.modals[this.modalCode]?.onConfirm || null;
    },
    onCancel() {
      return this.modals[this.modalCode]?.onCancel || null;
    },
  },
  methods: {
    ...mapMutations('modal', ['hideModal']),
    cancel() {
      if (this.onCancel) this.onCancel();
      this.hideModal(this.modalCode);
    },
    confirm() {
      if (this.onConfirm) this.onConfirm();
      this.hideModal(this.modalCode);
    }
  }
};
</script>